<template>
  <Card class="select-contact-card" v-bind="$attrs" :class="['select-contact-card--' + theme]">
    <template #header>
      <Avatar :value="avatarComp" :size="avatarSize" />
    </template>
    <template #default>
      <div>
        <div class="select-contact-card__title">
          <slot name="title">
            {{ title || value[titleField] }}

            <span
              v-if="company || $path(companyField, value)"
              class="ml-1 badge badge--type-default badge--theme-default"
              >{{ company || $path(companyField, value) }}</span
            >
          </slot>
        </div>
        <div v-if="subtitle || value[subtitleField]" class="select-contact-card__subtitle">
          <slot name="subtitle">
            {{ subtitle || value[subtitleField] }}
          </slot>
        </div>
      </div>
      <div v-if="$slots.custom" class="select-contact-card__custom">
        <slot name="custom" />
      </div>
    </template>
  </Card>
</template>

<script>
import Card from '@/components/Card'
import Avatar from '@/components/Avatar'

export default {
  props: {
    value: Object,
    theme: {
      type: String,
      enum: ['card', 'list'],
      default: 'card',
    },
    title: [String, Boolean],
    titleField: {
      type: String,
      default: 'name',
    },
    subtitle: [String, Boolean],
    subtitleField: {
      type: String,
      default: 'email',
    },
    company: [String, Boolean],
    companyField: {
      type: String,
      default: 'company.name',
    },
    avatar: String,
  },
  computed: {
    avatarComp() {
      return this.avatar || (this.value || {}).avatar
    },
    avatarSize() {
      switch (this.theme) {
        case 'list':
          return 'medium'
        default:
          return 'large'
      }
    },
  },
  components: {
    Card,
    Avatar,
  },
}
</script>

<style lang="scss">
.select-contact-card {
  text-align: center;
  line-height: 1;

  &.select-contact-card--list {
    text-align: left;
    flex-direction: row;
    align-items: center;

    box-shadow: none;
    background-color: transparent;

    .card__header,
    .card__content {
      padding: 0;
    }

    .card__header {
      flex-grow: 0;
      padding-right: 0.75rem;
    }
  }

  .card__header {
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: none;
    padding-bottom: 0;
    min-height: initial;
  }

  &__title {
    font-weight: bold;
    font-size: 1rem;
  }

  &__subtitle {
    opacity: 0.5;
    font-size: 0.9em;
    margin-top: 0.4rem;
  }
}
</style>
